<template>
    <div class="col-lg-4" v-if="model" data-aos="fade-in">
        <div class="module-card-item">
            <NuxtLink :to="link">
                <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow">            
                    <div class="logo">
                        <SmartLinkStandaloneElement :codename="type.elements.modality.codename">
                            <div class="modality">
                                <span class="icon" :class="modalityName"></span>
                                <span class="text">{{ model?.elements?.modality?.value.map(x => x.name).join(",").toUpperCase() }}</span>
                            </div>                            
                        </SmartLinkStandaloneElement>
                    </div>
                    <div class="title">
                        <SmartLinkStandaloneElement :codename="type.elements.module_title.codename">
                            <h3 v-if="model?.elements?.module_title?.value">{{ model?.elements?.module_title?.value }}</h3>
                        </SmartLinkStandaloneElement>
                    </div>    
                    <div class="description">
                        <SmartLinkStandaloneElement :codename="type.elements.contributors.codename">
                            <p v-if="model?.elements?.contributors?.value?.length > 0">Contributors: {{ shortDescription }}</p>
                        </SmartLinkStandaloneElement>
                    </div>
                </SmartLinkItemComponent>
            </NuxtLink>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { contentTypes, type PartnerItemModel, type ModuleItemModel } from '~~/app/models';
const type = contentTypes.module_item;
const pageStore = usePageStore();
const props = defineProps<{ model: ModuleItemModel, link?:string }>();
const shortDescription = computed(() =>  pageStore.getListAs<PartnerItemModel>(props?.model?.elements?.contributors?.value).map((x: any) => x?.elements?.partner_title?.value).join(', '));

const modalityName = computed(() => 
  (props.model?.elements?.modality?.value || []).map((x: any) =>
    x.name.toLowerCase().replace(/\s+/g, '-')
  )
)
</script>